/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_Meta_DescriptionInputs */

const ja_news_meta_description = /** @type {(inputs: News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAINからのお知らせ、ニュース、プレスリリースをご紹介します。東京を拠点に、日本・アジア市場向けゲームマーケティング、eスポーツ制作、クリエイティブサービスを提供しています。`)
};

const en_news_meta_description = /** @type {(inputs: News_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the latest news, announcements, and press releases from PLAYBRAIN, a Tokyo-based game marketing agency specializing in Japan and Asia, esports production, gaming campaigns, and creative services.`)
};

/**
* | output |
* | --- |
* | "Read the latest news, announcements, and press releases from PLAYBRAIN, a Tokyo-based game marketing agency specializing in Japan and Asia, esports productio..." |
*
* @param {News_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const news_meta_description = /** @type {((inputs?: News_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_news_meta_description(inputs)
	return en_news_meta_description(inputs)
});